import { ServiceFetch } from '../service-fetch'

export default class FactInvoiceSupplierModel extends ServiceFetch {
    getFactInvoiceSupplierBy = (data) => this.authFetch({
        url: 'fact-invoice-supplier/getFactInvoiceSupplierBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}